import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { useEffect, useRef } from 'react';
import './App.css';
import './pages/ElLugar.css';
import './pages/Amenities.css';
import './pages/Viviendas.css';
import './pages/VidaNautica.css';
import './pages/Ubicacion.css';
import videoBg from './assets/video-bg.mp4';
import HeaderManager from './components/HeaderManager';

function App() {
  // Fix for sticky sections scrolling - ONLY for the first header
  useEffect(() => {
    const handleAnchorClick = (e) => {
      const target = e.target.closest('a[href^="#"]');
      if (!target) return;
      
      const href = target.getAttribute('href');
      if (href === '#') return;
      
      const header = target.closest('.header-video');
      if (!header) return;
      
      const targetId = href.substring(1);
      let targetElement = document.getElementById(`anchor-${targetId}`);
      if (!targetElement) {
        targetElement = document.getElementById(targetId);
      }
      
      if (targetElement) {
        e.preventDefault();
        const headerHeight = 100;
        const elementPosition = targetElement.getBoundingClientRect().top + window.pageYOffset;
        const offsetPosition = elementPosition - headerHeight;
        
        window.scrollTo({
          top: offsetPosition,
          behavior: 'smooth'
        });
      }
    };

    document.addEventListener('click', handleAnchorClick);
    return () => document.removeEventListener('click', handleAnchorClick);
  }, []);

      // Handle scroll arrow fade
    useEffect(() => {
      const handleScroll = () => {
        const scrollArrow = document.querySelector('.scroll-arrow');
        if (!scrollArrow) return;
        
        const scrollPosition = window.scrollY;
        const windowHeight = window.innerHeight;
        const documentHeight = document.documentElement.scrollHeight;
        
        // Calculate how close we are to the bottom (in pixels)
        const distanceFromBottom = documentHeight - (scrollPosition + windowHeight);
        
        // Start fading when within 400px of the bottom
        if (distanceFromBottom < 400) {
          const opacity = Math.max(0, distanceFromBottom / 400);
          scrollArrow.style.opacity = opacity * 0.7;
          if (distanceFromBottom < 50) {
            scrollArrow.classList.add('hidden');
          } else {
            scrollArrow.classList.remove('hidden');
          }
        } else {
          scrollArrow.classList.remove('hidden');
          scrollArrow.style.opacity = 0.7;
        }
      };

      window.addEventListener('scroll', handleScroll);
      return () => window.removeEventListener('scroll', handleScroll);
    }, []);

  // Function to handle section toggle - closes all others
// Function to handle section toggle - closes all others WITHOUT scrolling
// Function to handle section toggle - closes all others WITHOUT scrolling
const toggleSection = (sectionId) => {
  // Get the current scroll position before any changes
  const scrollY = window.scrollY;
  
  const allContents = document.querySelectorAll('.details-expanded-content');
  const allButtons = document.querySelectorAll('.details-expand-btn');
  
  const currentContent = document.getElementById(`expand-${sectionId}`);
  const currentButton = document.querySelector(`#${sectionId} .details-expand-btn`);
  
  if (!currentContent) return;
  
  const isExpanded = currentContent.classList.contains('expanded');
  
  // Temporarily disable smooth scrolling to prevent any animated jumps
  const originalScrollBehavior = document.documentElement.style.scrollBehavior;
  document.documentElement.style.scrollBehavior = 'auto';
  
  // Perform the toggle
  allContents.forEach(content => {
    content.classList.remove('expanded');
  });
  allButtons.forEach(btn => {
    btn.classList.remove('active');
  });
  
  if (!isExpanded) {
    currentContent.classList.add('expanded');
    if (currentButton) {
      currentButton.classList.add('active');
    }
  }
  
  // Force the browser to maintain the exact scroll position
  // Use multiple requestAnimationFrames to ensure layout is fully complete
  requestAnimationFrame(() => {
    requestAnimationFrame(() => {
      requestAnimationFrame(() => {
        window.scrollTo({
          top: scrollY,
          behavior: 'auto'
        });
        // Restore original scroll behavior
        document.documentElement.style.scrollBehavior = originalScrollBehavior;
      });
    });
  });
};

  // Function to navigate to section
  const goToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      const headerHeight = 100;
      const elementPosition = element.getBoundingClientRect().top + window.pageYOffset;
      const offsetPosition = elementPosition - headerHeight;
      window.scrollTo({
        top: offsetPosition,
        behavior: 'smooth'
      });
    }
  };

  // WhatsApp contact function
  const openWhatsApp = () => {
    const phoneNumber = '5491123119994';
    const message = 'Hola, me gustaría conocer más sobre Venice Tigre.';
    const url = `https://wa.me/${phoneNumber}?text=${encodeURIComponent(message)}`;
    window.open(url, '_blank');
  };

  // Function to handle volver click - goes to top of page
  const goToHomepage = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  };

  return (
    <Router>
      <Routes>
        <Route path="/" element={
          <div className="App">
            <HeaderManager />
            
            {/* ===== HEADER - Video Sections ===== */}
            <header className="header header-video">
              <nav className="nav-container">
                <ul className="nav-list">
                  <li><a href="#el-lugar">EL LUGAR</a></li>
                  <li><a href="#amenities">AMENITIES</a></li>
                  <li><a href="#viviendas">VIVIENDAS</a></li>
                  <li><a href="#vida-nautica">VIDA NÁUTICA</a></li>
                  <li><a href="#ubicacion">UBICACIÓN</a></li>
                  <li><a href="#contacto">CONTACTO</a></li>
                </ul>
              </nav>
            </header>

            {/* Fixed video background */}
          <div className="video-background">
            <video autoPlay muted loop playsInline>
              <source src={videoBg} type="video/mp4" />
              Your browser does not support the video tag.
            </video>
          </div>

          {/* Floating scroll arrow */}
          <div className="scroll-arrow">↓</div>

            {/* Video content overlay */}
            <div className="content">
              <section className="section section-one">
                <img 
                  src="/images/VENICE_LOGO_WHITE.png" 
                  alt="VENICE TIGRE" 
                  className="hero-logo"
                />
                
              </section>

              <section className="section section-two">
                <h2>LO MEJOR DEL DELTA<br />Y LA VIDA URBANA</h2>
                <p>Un barrio náutico sobre el Río Luján, rodeado de naturaleza y conectado con la ciudad.</p>
                {/* <button 
                  className="explorar-btn"
                  onClick={() => goToSection('el-lugar')}
                >
                  EXPLORAR
                </button> */}
              </section>
            </div>

            {/* ===== SECOND HEADER - Sticky ===== */}
            <header className="header header-sticky">
              <div className="header-sticky-container">
                <div className="header-sticky-left">
                  <img 
                    src="/images/VENICE_LOGO_BLACK.png" 
                    alt="VENICE TIGRE" 
                    className="header-logo"
                  />
                </div>
                <nav className="header-sticky-nav">
                  <ul>
                    <li><a href="#" onClick={(e) => { e.preventDefault(); goToSection('el-lugar'); }}>EL LUGAR</a></li>
                    <li><a href="#" onClick={(e) => { e.preventDefault(); goToSection('amenities'); }}>AMENITIES</a></li>
                    <li><a href="#" onClick={(e) => { e.preventDefault(); goToSection('viviendas'); }}>VIVIENDAS</a></li>
                    <li><a href="#" onClick={(e) => { e.preventDefault(); goToSection('vida-nautica'); }}>VIDA NÁUTICA</a></li>
                    <li><a href="#" onClick={(e) => { e.preventDefault(); goToSection('ubicacion'); }}>UBICACIÓN</a></li>
                    <li><a href="#" onClick={(e) => { e.preventDefault(); goToSection('contacto'); }}>CONTACTO</a></li>
                  </ul>
                </nav>
              </div>
            </header>

            {/* ===== EXPANDABLE SECTIONS (formerly Details) ===== */}
            <div className="details-main">
              
              {/* Section: EL LUGAR */}
              <div 
                id="el-lugar"
                className="details-section"
                style={{ backgroundColor: '#bec4af' }}
              >
                <button 
                  className="details-expand-btn"
                  onClick={() => toggleSection('el-lugar')}
                >
                  <span>EL LUGAR</span>
                  <span className="details-arrow">▼</span>
                </button>
                
                <div 
                  id="expand-el-lugar"
                  className="details-expanded-content"
                >
                  <div className="details-expanded-inner el-lugar-content">
                    <div className="el-lugar-text">
                      <p>
                        Sobre un predio de 32 hectáreas, con 500 metros de costa sobre el Río Luján, VENICE TIGRE propone un estilo de vida que integra naturaleza, arquitectura contemporánea y vida urbana. 
<br/><br/>El canal interno navegable, el puerto, las áreas verdes, las plazas y los senderos conectan los distintos sectores del barrio y hacen que caminar, encontrarse y disfrutar del paisaje sean parte de la vida cotidiana.

                      </p>
                    </div>

                    {/* <div className="el-lugar-divider"></div>

                    <div className="el-lugar-image">
                      <img 
                        src="/images/ellugarbig.png" 
                        alt="El Lugar - Venice Tigre" 
                      />
                    </div> */}

                    <div className="el-lugar-divider"></div>

                    <div className="el-lugar-cards">
                      <div className="el-lugar-card" style={{ backgroundColor: '#d1b8b0' }}>
                        <h3>32</h3>
                        <p>HECTÁREAS TOTALES </p>
                        <div className="el-lugar-card-image">
                          <img src="/images/EL1.jpg" alt="Hectáreas" />
                        </div>
                      </div>

                      <div className="el-lugar-card" style={{ backgroundColor: '#ecd9c6' }}>
                        <h3>500</h3>
                        <p>METROS LINEALES </p>
                        <div className="el-lugar-card-image">
                          <img src="/images/EL2.png" alt="Arquitectura" />
                        </div>
                      </div>

                      <div className="el-lugar-card" style={{ backgroundColor: '#c2d2d6' }}>
                        <h3>5</h3>
                        <p>EDIFICIOS TERMINADOS</p>
                        <div className="el-lugar-card-image">
                          <img src="/images/EL3.png" alt="Comunidad" />
                        </div>
                      </div>

                      <div className="el-lugar-card" style={{ backgroundColor: '#fff3e6' }}>
                        <h3>600</h3>
                        <p>VIVIENDAS ENTREGADAS</p>
                        <div className="el-lugar-card-image">
                          <img src="/images/EL4.jpg" alt="Conectividad" />
                        </div>
                      </div>
                    </div>
                    
                    <div className="el-lugar-divider"></div>

                    <div className="el-lugar-gallery">
                      <div className="el-lugar-gallery-track">
                        <img src="/images/gallery1.jpg" alt="Gallery 1" />
                        <img src="/images/gallery2.jpg" alt="Gallery 2" />
                        <img src="/images/gallery3.jpg" alt="Gallery 3" />
                        <img src="/images/gallery4.jpg" alt="Gallery 4" />
                        <img src="/images/gallery5.png" alt="Gallery 5" />
                        <img src="/images/gallery6.jpg" alt="Gallery 6" />
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              {/* Section: AMENITIES */}
              <div 
                id="amenities"
                className="details-section"
                style={{ backgroundColor: '#d1b8b0' }}
              >
                <button 
                  className="details-expand-btn"
                  onClick={() => toggleSection('amenities')}
                >
                  <span>AMENITIES</span>
                  <span className="details-arrow">▼</span>
                </button>
                
                <div 
                  id="expand-amenities"
                  className="details-expanded-content"
                >
                  <div className="details-expanded-inner amenities-content">
                    <div className="amenities-text">
                      <p>
                        El diseño de VENICE TIGRE integra grandes áreas verdes con equipamiento de primer nivel:
                        sectores sociales, deportivos y recreativos distribuidos a lo largo del canal y de los
                        edificios, para que la vida cotidiana se sienta como estar siempre de vacaciones.
                      </p>
                    </div>

                    <div className="amenities-divider"></div>

                    <div className="amenities-icons">
                      <div className="amenities-icon-item">
                        <img src="/images/Iconos-1.png" alt="" />
                        <span>Puerto y marinas</span>
                      </div>
                      <div className="amenities-icon-item">
                        <img src="/images/Iconos-2.png" alt="" />
                        <span>Guardería <br/>de Kayaks</span>
                      </div>
                      <div className="amenities-icon-item">
                        <img src="/images/Iconos-3.png" alt="" />
                        <span>Seguridad <br/>24 horas</span>
                      </div>
                      <div className="amenities-icon-item">
                        <img src="/images/Iconos-4.png" alt="" />
                        <span>Circuitos de<br/>contemplación</span>
                      </div>
                      <div className="amenities-icon-item">
                        <img src="/images/Iconos-5.png" alt="" />
                        <span>Parque</span>
                      </div>
                      <div className="amenities-icon-item">
                        <img src="/images/Iconos-6.png" alt="" />
                        <span>Gimnasio <br/>y sauna</span>
                      </div>
                      <div className="amenities-icon-item">
                        <img src="/images/Iconos-7.png" alt="" />
                        <span>Cafetería</span>
                      </div>
                      <div className="amenities-icon-item">
                        <img src="/images/Iconos-8.png" alt="" />
                        <span>Sum</span>
                      </div>
                      <div className="amenities-icon-item">
                        <img src="/images/Iconos-9.png" alt="" />
                        <span>Lounge exterior</span>
                      </div>
                      <div className="amenities-icon-item">
                        <img src="/images/Iconos-10.png" alt="" />
                        <span>Fogoneros</span>
                      </div>
                      <div className="amenities-icon-item">
                        <img src="/images/Iconos-11.png" alt="" />
                        <span>Canchas de <br/>pádel</span>
                      </div>
                      <div className="amenities-icon-item">
                        <img src="/images/Iconos-12.png" alt="" />
                        <span>Plazas de <br/>juegos</span>
                      </div>
                      <div className="amenities-icon-item">
                        <img src="/images/Iconos-13.png" alt="" />
                        <span>Plaza central</span>
                      </div>
                      <div className="amenities-icon-item">
                        <img src="/images/Iconos-14.png" alt="" />
                        <span>Senderos <br/>peatonales</span>
                      </div>
                      <div className="amenities-icon-item">
                        <img src="/images/Iconos-15.png" alt="" />
                        <span>Cocheras de <br/>cortesía</span>
                      </div>
                      <div className="amenities-icon-item">
                        <img src="/images/Iconos-16.png" alt="" />
                        <span>Pileta con <br/>solárium</span>
                      </div>
                      <div className="amenities-icon-item">
                        <img src="/images/Iconos-17.png" alt="" />
                        <span>Lugar de estar<br/>interior y exterior</span>
                      </div>
                      <div className="amenities-icon-item">
                        <img src="/images/Iconos-18.png" alt="" />
                        <span>Co-Working</span>
                      </div>
                    </div>

                    <div className="amenities-divider"></div>

                    <div className="amenities-gallery">
                      <div className="amenities-gallery-track">
                        <img src="/images/amenities-gallery1.jpg" alt="Gallery 1" />
                        <img src="/images/amenities-gallery2.jpg" alt="Gallery 2" />
                        <img src="/images/amenities-gallery3.jpg" alt="Gallery 3" />
                        <img src="/images/amenities-gallery4.jpg" alt="Gallery 4" />
                        <img src="/images/amenities-gallery5.jpg" alt="Gallery 5" />
                        <img src="/images/amenities-gallery6.jpg" alt="Gallery 6" />
                        <img src="/images/amenities-gallery7.png" alt="Gallery 7" />
                        <img src="/images/amenities-gallery8.png" alt="Gallery 8" />
                        <img src="/images/amenities-gallery9.png" alt="Gallery 9" />
                        <img src="/images/amenities-gallery10.png" alt="Gallery 10" />
                        <img src="/images/amenities-gallery11.png" alt="Gallery 11" />
                        <img src="/images/amenities-gallery12.png" alt="Gallery 12" />
                        <img src="/images/amenities-gallery13.png" alt="Gallery 13" />
                        <img src="/images/amenities-gallery14.png" alt="Gallery 14" />                  
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              {/* Section: VIVIENDAS */}
              <div 
                id="viviendas"
                className="details-section"
                style={{ backgroundColor: '#ecd9c6' }}
              >
                <button 
                  className="details-expand-btn"
                  onClick={() => toggleSection('viviendas')}
                >
                  <span>VIVIENDAS</span>
                  <span className="details-arrow">▼</span>
                </button>
                
                <div 
                  id="expand-viviendas"
                  className="details-expanded-content"
                >
                  <div className="details-expanded-inner viviendas-content">
                    <div className="viviendas-text">
                      <p>
                        Diseñadas para priorizar la luz natural, las visuales abiertas, la conexión entre interior y exterior y, en propuestas seleccionadas, la posibilidad de contar con amarra.
              <br/><br/>Unidades listas para vivir y nuevos desarrollos que amplían las maneras de ser parte de VENICE.

                      </p>
                    </div>

                    <div className="viviendas-divider"></div>

                    <div className="viviendas-cards">
                      <div 
                        className="viviendas-card type-1" 
                        style={{ backgroundColor: '#c2d2d6' }}
                      >
                        <div className="viviendas-card-left">
                          <h3 className="viviendas-card-title">GOLETAS</h3>
                          <p className="viviendas-card-description">Eleva la experiencia de vivir junto al agua con dos <br />torres de 12 pisos, vistas abiertas al río y a la ciudad.</p>
                          <p className="viviendas-card-description">
                            Departamentos de 1 y 2 dormitorios, pileta con solárium, <br />laundry y cocheras cubiertas y semicubiertas.
                          </p>
                          
                          <div className="viviendas-card-columns">
                            <div className="viviendas-col">
                              <div className="viviendas-col-label">Goletas I</div>
                              <div className="viviendas-col-value">Departamentos de 1 dormitorio</div>
                            </div>
                            <div className="viviendas-col">
                              <div className="viviendas-col-label">Goletas II</div>
                              <div className="viviendas-col-value">Departamentos de 1 y 2 dormitorios</div>
                            </div>
                          </div>
                          
                          <div className="viviendas-card-small-text">
                            <img src="/images/metric.png" alt="m²" className="metric-icon" />
                            48 a 71 m²
                          </div>
                        </div>
                        
                        <div className="viviendas-card-right">
                          <img src="/images/viviendas1.jpg" alt="Vivienda A" />
                        </div>
                      </div>

                      <div 
                        className="viviendas-card type-2" 
                        style={{ backgroundColor: '#bec4af' }}
                      >
                        <div className="viviendas-card-right">
                          <img src="/images/viviendas2.jpg" alt="Vivienda B" />
                        </div>
                        
                        <div className="viviendas-card-left">
                          <h3 className="viviendas-card-title">CRUCEROS</h3>
                          <p className="viviendas-card-description">Edificio con departamentos pasantes con vistas al puerto, de diseño <br/>escalonado, con unidades luminosas.</p>
                          <p className="viviendas-card-description">
                            1, 2 y 3 dormitorios en una ubicación central del barrio.
                          </p>
                          <div className="viviendas-card-small-text">
                            <img src="/images/metric.png" alt="m²" className="metric-icon" />
                            57 a 162 m²
                          </div>
                        </div>
                      </div>

                      <div 
                        className="viviendas-card type-1" 
                        style={{ backgroundColor: '#d1b8b0' }}
                      >
                        <div className="viviendas-card-left">
                          <h3 className="viviendas-card-title">BALANDRAS</h3>
                          <p className="viviendas-card-description">Vivir entre verde y agua, con diseño moderno y vistas abiertas.</p>                 
                          <div className="viviendas-card-columns">
                            <div className="viviendas-col">
                              <div className="viviendas-col-label">Balandras I</div>
                              <div className="viviendas-col-value">Departamentos de 1, 2 y 3 dormitorios</div>
                            </div>
                            <div className="viviendas-col">
                              <div className="viviendas-col-label">Balandras II</div>
                              <div className="viviendas-col-value">Departamentos de 1, 2 y 3 dormitorios</div>
                            </div>
                          </div>
                          
                          <div className="viviendas-card-small-text">
                            <img src="/images/metric.png" alt="m²" className="metric-icon" />
                            57 a 167 m²
                          </div>
                        </div>
                        
                        <div className="viviendas-card-right">
                          <img src="/images/viviendas3.jpg" alt="Vivienda C" />
                        </div>
                      </div>

                      <div 
                        className="viviendas-card type-2" 
                        style={{ backgroundColor: '#fff3e6' }}
                      >
                        <div className="viviendas-card-right">
                          <img src="/images/viviendas4.jpg" alt="Vivienda D" />
                        </div>
                        
                        <div className="viviendas-card-left">
                          <h3 className="viviendas-card-title">FALÚAS</h3>
                          <p className="viviendas-card-description">Conjunto de 12 residencias únicas en tipologías de <br/>planta baja, dúplex y tríplex.</p>
                          <p className="viviendas-card-description">
                            La mayoría de las unidades cuenta con terrazas y amarras al canal.
                          </p>
                          <div className="viviendas-card-small-text">
                            <img src="/images/metric.png" alt="m²" className="metric-icon" />
                            158 a 244 m²
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              {/* Section: VIDA NÁUTICA */}
              <div 
                id="vida-nautica"
                className="details-section"
                style={{ backgroundColor: '#c2d2d6' }}
              >
                <button 
                  className="details-expand-btn"
                  onClick={() => toggleSection('vida-nautica')}
                >
                  <span>VIDA NÁUTICA</span>
                  <span className="details-arrow">▼</span>
                </button>
                
                <div 
                  id="expand-vida-nautica"
                  className="details-expanded-content"
                >
                  <div className="details-expanded-inner vida-nautica-content">
                    <div className="vida-nautica-text">
                      <p>
                        Un barrio náutico con canal central y salida directa al Río Luján,
                        pensado para disfrutar el agua todos los días.
                      </p>
                    </div>

                    <div className="vida-nautica-divider"></div>

                    <div className="vida-nautica-cards">
                      <div 
                        className="vida-nautica-card type-1" 
                        style={{ backgroundColor: '#bec4af' }}
                      >
                        <div className="vida-nautica-card-left">
                          <h3 className="vida-nautica-card-title">CANAL NAVEGABLE</h3>
                          <h4 className="vida-nautica-card-subtitle">Un recorrido de agua que atraviesa el barrio y conecta directamente <br/>con el río Luján, para navegar, remar o pasear sin salir de casa.</h4>
                        </div>
                        
                        <div className="vida-nautica-card-right">
                          <img src="/images/nautica1.jpg" alt="Vida Náutica A" />
                        </div>
                      </div>

                      <div 
                        className="vida-nautica-card type-2" 
                        style={{ backgroundColor: '#d1b8b0' }}
                      >
                        <div className="vida-nautica-card-right">
                          <img src="/images/nautica2.jpg" alt="Vida Náutica B" />
                        </div>
                        
                        <div className="vida-nautica-card-left">
                          <h3 className="vida-nautica-card-title">AMARRAS</h3>
                          <h4 className="vida-nautica-card-subtitle">Marinas diseñadas para lanchas, veleros y embarcaciones livianas, con acceso<br/>cómodo y seguro desde los sectores residenciales y el Puerto principal.</h4>
                        </div>
                      </div>

                      <div 
                        className="vida-nautica-card type-3" 
                        style={{ backgroundColor: '#ecd9c6' }}
                      >
                        <div className="vida-nautica-card-left">
                          <h3 className="vida-nautica-card-title">VISTAS AL RÍO</h3>
                          <h4 className="vida-nautica-card-subtitle">Vistas abiertas al canal y al Río Luján que convierten al agua en<br/>protagonista, desde tu hogar hasta los espacios comunes.</h4>
                        </div>
                        
                        <div className="vida-nautica-card-right">
                          <img src="/images/nautica3.jpg" alt="Vida Náutica C" />
                        </div>
                      </div>

                      <div 
                        className="vida-nautica-card type-4" 
                        style={{ backgroundColor: '#fff3e6' }}
                      >
                        <div className="vida-nautica-card-right">
                          <img src="/images/nautica4.jpg" alt="Vida Náutica D" />
                        </div>
                        
                        <div className="vida-nautica-card-left">
                          <h3 className="vida-nautica-card-title">GUARDERÍA DE KAYAKS</h3>
                          <h4 className="vida-nautica-card-subtitle">Guardería y bajada directa de kayaks al canal, para remar todo el año.</h4>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              {/* Section: UBICACIÓN */}
              <div 
                id="ubicacion"
                className="details-section"
                style={{ backgroundColor: '#fff3e6' }}
              >
                <button 
                  className="details-expand-btn"
                  onClick={() => toggleSection('ubicacion')}
                >
                  <span>UBICACIÓN</span>
                  <span className="details-arrow">▼</span>
                </button>
                
                <div 
                  id="expand-ubicacion"
                  className="details-expanded-content"
                >
                  <div className="details-expanded-inner ubicacion-content">
                    {/* Two column layout */}
                    <div className="ubicacion-layout">
                      
                      {/* LEFT COLUMN - Fixed text */}
                      <div className="ubicacion-text">
                        <p>
                          VENICE TIGRE está a pocas cuadras del centro de Tigre, cerca de servicios, comercios, bancos, restaurantes y del Puerto de Frutos. Su ubicación permite moverse con facilidad en auto, tren o transporte fluvial, combinando la vida náutica con la comodidad urbana de todos los días.
                        </p>
                      </div>

                      {/* RIGHT COLUMN - Icons + Interactive Info */}
                      <div className="ubicacion-right">
                        
                        {/* Icons Row */}
                        <div className="ubicacion-icons-row">
                          <div 
                            className="ubicacion-icon-item active" 
                            data-target="car"
                            onClick={(e) => {
                              const target = e.currentTarget.dataset.target;
                              document.querySelectorAll('.ubicacion-icon-item').forEach(icon => {
                                icon.classList.remove('active');
                              });
                              e.currentTarget.classList.add('active');
                              document.querySelectorAll('.ubicacion-info-text').forEach(text => {
                                text.classList.remove('active');
                              });
                              document.getElementById(`info-${target}`).classList.add('active');
                            }}
                          >
                            <img src="/images/car.svg" alt="Auto" />
                            <span>Auto</span>
                          </div>

                          <div 
                            className="ubicacion-icon-item" 
                            data-target="train"
                            onClick={(e) => {
                              const target = e.currentTarget.dataset.target;
                              document.querySelectorAll('.ubicacion-icon-item').forEach(icon => {
                                icon.classList.remove('active');
                              });
                              e.currentTarget.classList.add('active');
                              document.querySelectorAll('.ubicacion-info-text').forEach(text => {
                                text.classList.remove('active');
                              });
                              document.getElementById(`info-${target}`).classList.add('active');
                            }}
                          >
                            <img src="/images/train.svg" alt="Tren" />
                            <span>Tren</span>
                          </div>

                          <div 
                            className="ubicacion-icon-item" 
                            data-target="bicycle"
                            onClick={(e) => {
                              const target = e.currentTarget.dataset.target;
                              document.querySelectorAll('.ubicacion-icon-item').forEach(icon => {
                                icon.classList.remove('active');
                              });
                              e.currentTarget.classList.add('active');
                              document.querySelectorAll('.ubicacion-info-text').forEach(text => {
                                text.classList.remove('active');
                              });
                              document.getElementById(`info-${target}`).classList.add('active');
                            }}
                          >
                            <img src="/images/bike.svg" alt="Bicicleta" />
                            <span>Bicicleta</span>
                          </div>

                          <div 
                            className="ubicacion-icon-item" 
                            data-target="walking"
                            onClick={(e) => {
                              const target = e.currentTarget.dataset.target;
                              document.querySelectorAll('.ubicacion-icon-item').forEach(icon => {
                                icon.classList.remove('active');
                              });
                              e.currentTarget.classList.add('active');
                              document.querySelectorAll('.ubicacion-info-text').forEach(text => {
                                text.classList.remove('active');
                              });
                              document.getElementById(`info-${target}`).classList.add('active');
                            }}
                          >
                            <img src="/images/walk.svg" alt="Caminando" />
                            <span>Caminando</span>
                          </div>

                          <div 
                            className="ubicacion-icon-item" 
                            data-target="boat"
                            onClick={(e) => {
                              const target = e.currentTarget.dataset.target;
                              document.querySelectorAll('.ubicacion-icon-item').forEach(icon => {
                                icon.classList.remove('active');
                              });
                              e.currentTarget.classList.add('active');
                              document.querySelectorAll('.ubicacion-info-text').forEach(text => {
                                text.classList.remove('active');
                              });
                              document.getElementById(`info-${target}`).classList.add('active');
                            }}
                          >
                            <img src="/images/ship.svg" alt="Lancha" />
                            <span>Lancha</span>
                          </div>
                        </div>

                        {/* Info Text Content */}
                        <div className="ubicacion-info-content">
                          <div id="info-car" className="ubicacion-info-text active">
                            <h4>Cómo llegar: en auto</h4>
                            <ul>
                              <li>Acceso por Av. Libertador</li>
                              <li>Acceso por Ramal Tigre, bajada Tigre Centro o Bajada Ruta Nacional 197</li>
                              <li>Acceso por Panamericana y Ruta Nacional 197</li>
                            </ul>
                          </div>

                          <div id="info-train" className="ubicacion-info-text">
                            <h4>Cómo llegar: en tren</h4>
                            <ul>
                              <li>10 cuadras de la Estación Tigre Ferrocarril Mitre</li>
                              <li>5 cuadras del Tren de la Costa</li>
                            </ul>
                          </div>

                          <div id="info-bicycle" className="ubicacion-info-text">
                            <h4>Cómo llegar: en bicicleta</h4>
                            <ul>
                              <li>5' Puerto de Frutos</li>
                              <li>15' Paseo Victoria</li>
                            </ul>
                          </div>

                          <div id="info-walking" className="ubicacion-info-text">
                            <h4>Cómo llegar: caminando</h4>
                            <ul>
                              <li>10' Boulevard Sáenz Peña</li>
                              <li>12' Mercados del Delta</li>
                              <li>14' Puerto de Frutos</li>
                              <li>18' Estación Fluvial Tigre</li>
                              <li>22' Parque de la Costa</li>
                            </ul>
                          </div>

                          <div id="info-boat" className="ubicacion-info-text">
                            <h4>Cómo llegar: en lancha</h4>
                            <ul>
                              <li>5' Puerto de Frutos</li>
                              <li>10' Club Náutico San Isidro</li>
                              <li>20' Puerto Olivos</li>
                              <li>50' Puerto Madero</li>
                              <li>90' Carmelo</li>
                            </ul>
                          </div>
                        </div>
                        
                      </div>
                      {/* END RIGHT COLUMN */}
                      
                    </div>
                    {/* END TWO COLUMN LAYOUT */}

                    <div className="ubicacion-divider"></div>

                    <div className="ubicacion-image">
                      <img 
                        src="/images/ubicacion.png" 
                        alt="Ubicación - Venice Tigre" 
                      />
                    </div>
                  </div>
                </div>
              </div>

              {/* Section: CONTACTO */}
              <div 
                id="contacto"
                className="details-section"
                style={{ backgroundColor: '#8d957e' }}
              >
                <button 
                  className="details-expand-btn"
                  onClick={() => toggleSection('contacto')}
                >
                  <span>CONTACTO</span>
                  <span className="details-arrow">▼</span>
                </button>
                
                <div 
                  id="expand-contacto"
                  className="details-expanded-content"
                >
                  <div className="details-expanded-inner">
                    <p>
                      <strong>Dirección</strong><br />
                      Solís y Río Luján | Tigre
                      <br/><br/>
                    </p>
                    <p>
                      <strong>Teléfono</strong><br />
                      +54 9 11 4075-7020
                      <br/><br/>
                    </p>
                    <p>
                      <strong>Instagram</strong><br/>
                      /venicetigre
                      <br/>
                    </p>
                  </div>
                </div>
              </div>

              {/* Section: VOLVER - Always expanded, scrolls to top */}
              {/* <div 
                id="volver"
                className="details-section volver-section"
                style={{ backgroundColor: '#3b4033' }}
                onClick={goToHomepage}
              >
                <div className="volver-content">
                  <span className="volver-title">VOLVER</span>
                </div>
              </div> */}

              {/* Footer - Only Logo */}
              <footer 
                className="footer-section details-footer"
                onClick={goToHomepage}
                style={{ cursor: 'pointer' }}
              >
                <div className="footer-bottom">
                  <img 
                    src="/images/VENICE_LOGO_WHITE.png" 
                    alt="VENICE TIGRE" 
                    className="footer-logo"
                  />
                </div>
              </footer>

            </div>

            {/* Floating WhatsApp Button */}
            <a 
              href="#" 
              className="whatsapp-float"
              onClick={(e) => {
                e.preventDefault();
                openWhatsApp();
              }}
              target="_blank"
              rel="noopener noreferrer"
              aria-label="Contactar por WhatsApp"
            >
              <img src="/images/wlogo.png" alt="WhatsApp" />
            </a>

          </div>
        } />
      </Routes>
    </Router>
  );
}

export default App;